import { render, staticRenderFns } from "./BuildTriggerTypeIcon.vue?vue&type=template&id=647c2374&scoped=true"
import script from "./BuildTriggerTypeIcon.vue?vue&type=script&lang=js"
export * from "./BuildTriggerTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c2374",
  null
  
)

export default component.exports